import {getPriceData} from '@salesforce/retail-react-app/app/utils/product-utils'
import {getControllerUrl} from './controllerUrlGenerator'
import sites from '../../../config/sites'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

export const transformGiftCertificateItems = (giftCertificateItems) => {
    if (!giftCertificateItems || giftCertificateItems.length === 0) return []
    return giftCertificateItems.map((item) => ({
        id: item.giftCertificateItemId,
        name: 'Cavender’s E-Gift Card',
        price: item.amount,
        quantity: 1,
        imageUrl: getAssetUrl('static/img/header/EGiftCard.png'),
        isGiftCertificate: true,
        recipientName: item.recipientName,
        recipientEmail: item.recipientEmail,
        senderName: item.senderName,
        message: item.message,
        productUrl: ''
    }))
}

export const transformBasketData = (products, basket) => {
    if (products && !Object.keys(products)?.length) {
        return {basketItems: [], productSubTotal: '0.00'}
    }
    let basketItems = []
    for (let productKey in products) {
        let product = products[productKey]

        const {
            id,
            name,
            price,
            currency,
            variationValues,
            tieredPrices,
            c_cloudinary,
            c_primaryCatergoryID,
            primaryCategoryId,
            c_style,
            c_selectedVariationSize,
            c_selectedStoreObj,
            c_shipToHomeOnPWA,
            c_instorePickupOnPWA,
            slugUrl,
            variationAttributes,
            imageGroups,
            c_productPromotionsDetails
        } = product

        const productUrl = slugUrl ? new URL(slugUrl).pathname : ''

        const basketItem = basket?.productItems?.find((item) => item?.productId == product?.id)
        const productItem = {
            id,
            name,
            price: `${parseFloat(price).toFixed(2)}`,
            priceAfterItemDiscount: basketItem?.priceAfterItemDiscount,
            quantity: basketItem?.quantity,
            tieredPrices,
            currency,
            variationValues,
            isPhysicalGiftCard: c_style === 'GIFT',
            imageUrl: c_cloudinary?.miniCartImage?.url || c_cloudinary?.url || null,
            priceData: getPriceData(product, {}),
            productUrl,
            c_primaryCatergoryID,
            primaryCategoryId,
            c_selectedVariationSize,
            c_consolidateDeliveries: basket?.c_consolidateDeliveries || '',
            c_storeId: basketItem?.c_selectedStoreId || '',
            c_selectedStoreObj,
            showShipToHome: c_shipToHomeOnPWA?.showShipToHome || false,
            showInStorePickup: c_instorePickupOnPWA?.enableInStorePickup || false,
            c_cloudinary,
            variationAttributes,
            imageGroups,
            c_productPromotionsDetails
        }
        basketItems.push(productItem)
    }
    return basketItems.reverse()
}
